import { configureStore } from "@reduxjs/toolkit";
import { userDetailReducer, userListReducer } from "./reducers/user.reducer";
// import { rawMaterialDetailReducer, rawMaterialListReducer } from "./reducers/raw-material.reducer";
import { employeeListReducer } from "./reducers/employee.reducer";
import { supplierListReducer } from "./reducers/supplier.reducer";
import { loginReducer, authReducer } from "./reducers/auth.reducer";
import { loaderReducer } from "./reducers/loader.reducer";
import { clientListReducer } from "./reducers/client.reducer";
import { productListReducer } from "./reducers/product.reducer";
import { packagingListReducer } from "./reducers/packaging.reducer";
import { settingReducer } from "./reducers/setting.reducer";
import { orderListReducer } from "./reducers/order.reducer";
import { invoiceListReducer } from "./reducers/invoice.reducer";
import { delivryNoteListReducer } from "./reducers/delivry_note.reducer";
import { packagingHistoryListReducer } from "./reducers/packaging_history.reducer";
import { categoryListReducer } from "./reducers/category.reducer";
import { articleListReducer } from "./reducers/article.reducer";
import { proformaInvoiceListReducer } from "./reducers/proforma_invoice.reducer";
import { expenseListReducer } from "./reducers/expense.reducer";
import { taskBambousListReducer, taskRambosListReducer } from "./reducers/task.reducer";
import { ramboListReducer } from "./reducers/rambo.reducer";
import { bambouListReducer } from "./reducers/bambou.reducer";

const initialState = {
    login: {
        loading: false,
        error: null
    },
    auth: {
        loading: true,
        me: null
    },
    loader: {
        loading: false
    },
    users: {
        loading: false,
        data: null
    },
    user: {
        loading: false,
        data: null
    },
    rambos: {
        loading: false,
        data: null
    },
    bambous: {
        loading: false,
        data: null
    },
    employees: {
        loading: false,
        data: null
    },
    suppliers: {
        loading: false,
        data: null
    },
    clients: {
        loading: false,
        data: null
    },
    products: {
        loading: false,
        data: null
    },
    orders: {
        loading: false,
        data: null
    },
    invoices: {
        loading: false,
        data: null
    },
    proformaInvoices: {
        loading: false,
        data: null
    },
    delivryNotes: {
        loading: false,
        data: null
    },
    packagingList: {
        loading: false,
        data: null
    },
    packagingHistoryList: {
        loading: false,
        data: null
    },
    categories: {
        loading: false,
        data: null
    },
    articles: {
        loading: false,
        data: null
    },
    expenses: {
        loading: false,
        data: null
    },
    taskRambos: {
        loading: false,
        data: null
    },
    taskBambous: {
        loading: false,
        data: null
    },
    setting: {
        loading: false,
        data: null
    }
};

export const store = configureStore({
    reducer: {
        login: loginReducer,
        auth: authReducer,
        loader: loaderReducer,
        users: userListReducer,
        user: userDetailReducer,
        rambos: ramboListReducer,
        bambous: bambouListReducer,
        employees: employeeListReducer,
        suppliers: supplierListReducer,
        clients: clientListReducer,
        products: productListReducer,
        orders: orderListReducer,
        invoices: invoiceListReducer,
        proformaInvoices: proformaInvoiceListReducer,
        delivryNotes: delivryNoteListReducer,
        packagingList: packagingListReducer,
        packagingHistoryList: packagingHistoryListReducer,
        categories: categoryListReducer,
        articles: articleListReducer,
        expenses: expenseListReducer,
        taskRambos: taskRambosListReducer,
        taskBambous: taskBambousListReducer,
        setting: settingReducer,
    },
    preloadedState: initialState 
});